<div class="down-arrow">
  <span class="iconify" data-icon="akar-icons:arrow-down"></span>
</div>
